import app from "flarum/forum/app";
import ServerStatisticsDataPage from "../ServerStatisticsDataPage";

export default class SCPServerStatisticsPage extends ServerStatisticsDataPage {
  statUrl() {
    return "https://rhd-api.tenmahw.com/scp/server/stat";
  }

  statName(key: string) {
    return app.translator.trans("rhodes-island.forum.scp_data." + key)
  }
}
